import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from '../../environments/environment';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.css']
})
export class NavigationComponent implements OnInit {
    @Input() isAdmin: boolean = false;
    currentRoute: string = null;

    get anaplanUrl(): string {
        return environment.anaplanUrl;
    }

    get documentationSiteUrl(): string {
        return environment.documentationSiteUrl;
    }

    get isAdminSelected(): boolean {
        return this.currentRoute?.toLowerCase().indexOf("admin") > -1;
    }

    get isCreateBookSelected(): boolean {
        return this.currentRoute?.toLowerCase() === "createbook";
    }

    get isCreateSiteSelected(): boolean {
        return this.currentRoute?.toLowerCase() === "createsite";
    }

    get isJobHistorySelected(): boolean {
        return this.currentRoute?.toLowerCase() === "admin/job-history";
    }

    get isJobQueueManagerSelected(): boolean {
        return this.currentRoute?.toLowerCase() === "admin/job-queue-manager";
    }

    get isJobStatsSelected(): boolean {
        return this.currentRoute?.toLowerCase() === "admin/job-stats";
    }

    get isManageWorkflowsSelected(): boolean {
        return this.currentRoute?.toLowerCase() === "admin/manage-workflows";
    }

    get isOrgManagerSelected(): boolean {
        return this.currentRoute?.toLowerCase() === "admin/org-manager";
    }

    get isRefreshLinksSelected(): boolean {
        return this.currentRoute?.toLowerCase() === "refreshlinks";
    }

    get isReportsSelected(): boolean {
        return this.currentRoute?.toLowerCase() === "reports";
    }

    get isSiteBannerSelected(): boolean {
        return this.currentRoute?.toLowerCase() === "admin/site-banner";
    }

    get sharepointSiteUrl(): string {
        return environment.sharepointSiteUrl;
    }

    constructor(private router: Router) { }

    ngOnInit(): void {
        this.router.events.subscribe((val) => {
            this.currentRoute = this.router.url.replace("/", "");
        });
    }
}
